module.exports = __webpack_public_path__ + "static/media/gross_motor_icon2f28a18f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/gross_motor_icon.svg
// module id = 1330
// module chunks = 0